import React from 'react';
import MolLink from '../../Basepage/parts/Menu/MolLink';
import { GetEanSearch } from './Componnents/Ean_search';
import './OpenList.scss';

interface OpenListProp {
  data: {
    orderInfoDetails: [];
    eanInfo: any;
  };
  apiBase: string;
}

export default class OpenList extends React.Component<OpenListProp> {
  addMessagePopup() {}
  render(): React.ReactNode {
    let GetEanSearch_local = GetEanSearch(
      '/konto/open',
      this.props.data.eanInfo,
    );
    let GetEanSearch_local_gui = GetEanSearch_local.gui;
    let eanSearchParam = GetEanSearch_local.eanSearchParam;
    let orderInfoDetails = this.props.data.orderInfoDetails ?? [];
    return (
      <div id="OpenList">
        {GetEanSearch_local_gui}
        <div id="messageContainer"></div>
        <table>
          <thead>
            <tr>
              <th>Datum</th>
              <th>Auftrag ID</th>
              <th>Bestellung ID</th>
              <th>EAN</th>
              <th>Bezeichnung</th>
              <th>Menge</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {orderInfoDetails.map((item: any, index) => {
              let classNameRow = 'row' + (index % 2 == 1 ? ' mod2' : '');

              let link =
                '/konto/mol_orders/' +
                item.mol_auftrag_id +
                '#pos_' +
                item.mol_auftrag_position_id;

              return (
                <tr key={'row_' + item.mol_auftrag_id} className={classNameRow}>
                  <td>{item.date_purchased}</td>
                  <td>
                    <MolLink to={link} href={link}>
                      {item.mol_auftrag_id}
                    </MolLink>
                  </td>
                  <td>{item.bestellreferenz}</td>
                  <td>{item.ean}</td>
                  <td>{item.pos_bezeichnung}</td>
                  <td>
                    {+item.menge - (+item.liefer_menge + +item.storno_menge)}
                  </td>
                  <td>
                    <a
                      className="storno"
                      onClick={() => {
                        debugger;
                        let stornoUrl = this.props.apiBase + '/Storno.php';
                        let body = {
                          mol_auftrag_id: item.mol_auftrag_id,
                          mol_auftrag_position_id: item.mol_auftrag_position_id,
                        };
                        let bodyString = JSON.stringify(body);

                        fetch(stornoUrl, {
                          method: 'POST',
                          credentials: 'include',
                          headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                          },
                          body: bodyString,
                        })
                          .then((res) => res.json())
                          .then(
                            (result) => {
                              debugger;
                              if (result.body.response.storno_state) {
                              } else {
                              }
                            },
                            (error) => {
                              debugger;
                            },
                          );
                      }}
                    >
                      storno anfragen
                    </a>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}
